"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocialMediaSubCategory = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
exports.SocialMediaSubCategory = (0, type_utils_1.makeEnum)({
    /** A link to an individual's social media profile */
    ProfileURL: 'PROFILE_URL',
    /** Fallback subcategory */
    SocialMedia: 'SOCIAL_MEDIA',
});
//# sourceMappingURL=socialMedia.js.map